/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LogTeamMeetingRequest
 */
export interface LogTeamMeetingRequest {
  /**
   *
   * @type {string}
   * @memberof LogTeamMeetingRequest
   */
  teamMemberId: string;
  /**
   *
   * @type {string}
   * @memberof LogTeamMeetingRequest
   */
  jamieMeetingId: string;
  /**
   *
   * @type {string}
   * @memberof LogTeamMeetingRequest
   */
  notes?: string | null;
}

/**
 * Check if a given object implements the LogTeamMeetingRequest interface.
 */
export function instanceOfLogTeamMeetingRequest(
  value: object,
): value is LogTeamMeetingRequest {
  if (!("teamMemberId" in value) || value["teamMemberId"] === undefined)
    return false;
  if (!("jamieMeetingId" in value) || value["jamieMeetingId"] === undefined)
    return false;
  return true;
}

export function LogTeamMeetingRequestFromJSON(
  json: any,
): LogTeamMeetingRequest {
  return LogTeamMeetingRequestFromJSONTyped(json, false);
}

export function LogTeamMeetingRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LogTeamMeetingRequest {
  if (json == null) {
    return json;
  }
  return {
    teamMemberId: json["teamMemberId"],
    jamieMeetingId: json["jamieMeetingId"],
    notes: json["notes"] == null ? undefined : json["notes"],
  };
}

export function LogTeamMeetingRequestToJSON(json: any): LogTeamMeetingRequest {
  return LogTeamMeetingRequestToJSONTyped(json, false);
}

export function LogTeamMeetingRequestToJSONTyped(
  value?: LogTeamMeetingRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamMemberId: value["teamMemberId"],
    jamieMeetingId: value["jamieMeetingId"],
    notes: value["notes"],
  };
}
